import camelCase        from 'lodash/camelCase'
import WizardController from '../../../wizard_controller'

export default class extends WizardController {

  static targets = [
    'extremitiesAbnormalitiesNoneOfTheAbove',
    'footAbnormalitiesNoneOfTheAbove',
    'footSymptomsNoneOfTheAbove',
    'fundalHeightDetails',
    'insulinInjectedDetails',
    'insulinInjectionSiteAbnormalitiesNoneOfTheAbove',
    'oralAbnormalitiesNoneOfTheAbove',
    'otherConditionsNoneOfTheAbove',
    'skinAbnormalitiesNoneOfTheAbove'
  ]

  toggleFundalHeightDetails({ currentTarget }) {
    this.toggleNoneInverseSelection({
      input:  currentTarget,
      target: this.fundalHeightDetailsTarget
    })
  }

  toggleInsulinInjectedDetails({ currentTarget }) {
    this.toggleNoneInverseSelection({
      input:  currentTarget,
      target: this.insulinInjectedDetailsTarget
    })
  }

  toggleNoneOfTheAbove({ currentTarget, params: { sectionType } }) {
    const targetsKey = camelCase(`${sectionType}_none_of_the_above_targets`)

    this.toggleCheckboxNoneOfTheAbove({
      input:         currentTarget,
      targets:       this[targetsKey],
      dispatchInput: false
    })
  }

}
